import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGamepad,
  faMapMarkerAlt,
  faMicrochip,
  faMobileScreen,
  faShieldHalved,
  faStore,
  faTags,
  faTruckFast
} from '@fortawesome/free-solid-svg-icons';

const services = [
  { title: 'Consoles and games', copy: 'PlayStation, Xbox, Nintendo, retro games and accessories bought, sold and traded.', icon: faGamepad },
  { title: 'Phones and tablets', copy: 'Quality mobile tech, straightforward trade-ins and local upgrade advice.', icon: faMobileScreen },
  { title: 'Gaming PCs', copy: 'Pre-built gaming PCs, performance checks, upgrades and component guidance.', icon: faMicrochip }
];

const proof = [
  { value: '15+', label: 'years trading locally' },
  { value: '1000s', label: 'items bought and sold' },
  { value: '7 days', label: 'open every week' },
  { value: '1 shop', label: 'proper local advice' }
];

const About = () => (
  <div className="content-page about-2026">
    <section className="about-cinematic-hero">
      <img className="about-hero-background" src="/images/2026/about/about-hero.webp" alt="Pixel art Game On shop filled with consoles, games and gaming technology" fetchPriority="high" />
      <div className="about-hero-content">
        <p className="pixel-kicker">Independent since player one</p>
        <p className="eyebrow">Game On Cosham</p>
        <h1>Built around gamers, not checkouts.</h1>
        <p>
          A proper local shop for consoles, games, phones, laptops and gaming PCs, with people who know the gear and advice you can actually use.
        </p>
        <div className="hero-actions">
          <Link className="pixel-button" to="/contact">Visit the shop</Link>
          <Link className="btn-ghost" to="/history">Our gaming history</Link>
        </div>
      </div>
      <div className="about-hero-proof" aria-label="Game On shop highlights">
        <div><strong>15+</strong><span>Years trading locally</span></div>
        <div><strong>Buy · Sell · Trade</strong><span>Cash or credit in store</span></div>
        <div><strong>7 days</strong><span>Open every week</span></div>
      </div>
    </section>

    <section className="story-band">
      <div>
        <p className="eyebrow">Our story</p>
        <h2>Built for people who want good gear without the guesswork.</h2>
      </div>
      <div className="story-copy">
        <p>
          We are a real high-street shop, not a faceless checkout. Bring in old tech, ask what something is worth, compare pre-owned options, or get help choosing a gaming PC that actually suits how you play.
        </p>
        <p>
          The shop is set up for quick trade-ins, tested stock and practical advice across consoles, games, phones, laptops and PC hardware.
        </p>
      </div>
    </section>

    <section className="proof-strip page-proof" aria-label="Game On facts">
      {proof.map((item) => (
        <div key={item.label}>
          <strong>{item.value}</strong>
          <span>{item.label}</span>
        </div>
      ))}
    </section>

    <section className="radar-section">
      <div className="radar-section-heading">
        <p className="eyebrow">What we do</p>
        <h2>Buy, sell, trade and help you upgrade.</h2>
      </div>
      <div className="category-grid">
        {services.map((service) => (
          <article className="category-card" key={service.title}>
            <FontAwesomeIcon icon={service.icon} />
            <h3>{service.title}</h3>
            <p>{service.copy}</p>
          </article>
        ))}
      </div>
    </section>

    <section className="visit-callout">
      <div>
        <p className="eyebrow">Cosham high street</p>
        <h2>Bring in your old tech and leave with options.</h2>
        <p>
          <FontAwesomeIcon icon={faMapMarkerAlt} /> 1-2 Crown Buildings, Cosham
          <FontAwesomeIcon icon={faShieldHalved} /> Tested stock
          <FontAwesomeIcon icon={faTags} /> Fair value
          <FontAwesomeIcon icon={faTruckFast} /> Free local collection
          <FontAwesomeIcon icon={faStore} /> Open 7 days
        </p>
      </div>
      <Link className="btn-red" to="/contact">Get directions</Link>
    </section>
  </div>
);

export default About;
